/**
 * Meta (Facebook) Pixel Utility & Event Tracker
 * Pixel ID: 1123614183532126
 */

/**
 * Track standard Meta Pixel events (e.g., 'PageView', 'Lead', 'Search', 'InitiateCheckout', 'Purchase', 'Contact')
 * @param {string} eventName - Standard Meta Event name
 * @param {object} params - Optional event parameters
 */
export const trackPixelEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', eventName, params);
      if (process.env.NODE_ENV !== 'production') {
        console.log(`[MetaPixel] Tracked: ${eventName}`, params);
      }
    }
  } catch (err) {
    console.warn('[MetaPixel] Tracking error:', err);
  }
};

/**
 * Track custom Meta Pixel events
 * @param {string} customEventName - Custom event name
 * @param {object} params - Optional parameters
 */
export const trackCustomPixelEvent = (customEventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('trackCustom', customEventName, params);
      if (process.env.NODE_ENV !== 'production') {
        console.log(`[MetaPixel] Custom Event: ${customEventName}`, params);
      }
    }
  } catch (err) {
    console.warn('[MetaPixel] Custom tracking error:', err);
  }
};
